export default __webpack_public_path__ + "static/media/vinyl-bg_alt.e5e464cf.jpg";